import { isEmpty } from 'lodash';

const getHostStockListResponse = (response, previousResponse, page) => {
  const totalData = response?.data?.totalData ?? 0;
  const totalPage = response?.data?.totalPage ?? 0;
  const currentPage = response?.data?.currentPage ?? 1;

  let stocks = response?.data?.stocks ?? [];

  if (!isEmpty(previousResponse) && page !== 1) {
    stocks = [...previousResponse, ...stocks];
  }

  return {
    stocks,
    totalData,
    totalPage,
    currentPage,
  };
};

export default getHostStockListResponse;
